webpackJsonp([19],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wxSetTitle; });
var wxSetTitle = function wxSetTitle(title) {
    document.title = title;
    var mobile = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(mobile)) {
        var iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';

        var iframeCallback = function iframeCallback() {
            setTimeout(function () {
                iframe.removeEventListener('load', iframeCallback);
                document.body.removeChild(iframe);
            }, 0);
        };
        iframe.addEventListener('load', iframeCallback);
        document.body.appendChild(iframe);
    }
};

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appStore_index_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menuTree_index_js__ = __webpack_require__(174);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        app: __WEBPACK_IMPORTED_MODULE_2__appStore_index_js__["a" /* default */],
        menu: __WEBPACK_IMPORTED_MODULE_3__menuTree_index_js__["a" /* default */]
    }
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moudules_login__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__moudules_home__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__moudules_menu__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__moudules_role__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__moudules_accountManagement__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__moudules_book__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__moudules_experienceManagement__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__moudules_banner__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__moudules_user__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__moudules_experienceNote__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__moudules_bannerManage__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__moudules_informationCenter__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__moudules_honoraryManage__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__moudules_caseClassManage__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__moudules_newsInformation__ = __webpack_require__(169);

















/* harmony default export */ __webpack_exports__["a"] = ({
  login: __WEBPACK_IMPORTED_MODULE_0__moudules_login__,
  home: __WEBPACK_IMPORTED_MODULE_1__moudules_home__,
  menu: __WEBPACK_IMPORTED_MODULE_2__moudules_menu__,
  role: __WEBPACK_IMPORTED_MODULE_3__moudules_role__,
  accountManagement: __WEBPACK_IMPORTED_MODULE_4__moudules_accountManagement__,
  book: __WEBPACK_IMPORTED_MODULE_5__moudules_book__,
  experienceManagement: __WEBPACK_IMPORTED_MODULE_6__moudules_experienceManagement__,
  banner: __WEBPACK_IMPORTED_MODULE_7__moudules_banner__,
  user: __WEBPACK_IMPORTED_MODULE_8__moudules_user__,
  experienceNote: __WEBPACK_IMPORTED_MODULE_9__moudules_experienceNote__,
  bannerManage: __WEBPACK_IMPORTED_MODULE_10__moudules_bannerManage__,
  informationCenter: __WEBPACK_IMPORTED_MODULE_11__moudules_informationCenter__,
  honoraryManage: __WEBPACK_IMPORTED_MODULE_12__moudules_honoraryManage__,
  caseClassManage: __WEBPACK_IMPORTED_MODULE_13__moudules_caseClassManage__,
  newsInformation: __WEBPACK_IMPORTED_MODULE_14__moudules_newsInformation__
});

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserList", function() { return getUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUpdate_user_status", function() { return getUpdate_user_status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Postreset_passwd", function() { return Postreset_passwd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllRole", function() { return getAllRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postAddAccount", function() { return postAddAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postDelete", function() { return postDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var getUserList = function getUserList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/user/list',
    method: 'POST',
    data: data
  });
};

var getUpdate_user_status = function getUpdate_user_status(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/user/update_user_status',
    method: 'POST',
    data: data
  });
};

var Postreset_passwd = function Postreset_passwd(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/user/reset_passwd',
    method: 'POST',
    data: data
  });
};

var getAllRole = function getAllRole(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/role/get_all_role',
    method: 'POST'
  });
};

var postAddAccount = function postAddAccount(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/user/save',
    method: 'POST',
    data: data
  });
};

var postDelete = function postDelete(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/user/delete',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBannerList", function() { return getBannerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postDeleteRow", function() { return postDeleteRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addBanner", function() { return addBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postUpdateBanner", function() { return postUpdateBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postEditBanner", function() { return postEditBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBannerDeletail", function() { return getBannerDeletail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBshelves_list", function() { return getBshelves_list; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postMove_sort", function() { return postMove_sort; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var getBannerList = function getBannerList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/list',
    method: 'POST',
    data: data
  });
};

var postDeleteRow = function postDeleteRow(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/delete',
    method: 'POST',
    data: data
  });
};

var addBanner = function addBanner(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/save',
    method: 'POST',
    data: data
  });
};

var postUpdateBanner = function postUpdateBanner(data, url) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: url,
    method: 'POST',
    data: data
  });
};

var postEditBanner = function postEditBanner(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/update',
    method: 'POST',
    data: data
  });
};

var getBannerDeletail = function getBannerDeletail(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/get',
    method: 'POST',
    data: data
  });
};

var getBshelves_list = function getBshelves_list() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/shelves_list',
    method: 'POST'
  });
};

var postMove_sort = function postMove_sort(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/move_sort',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBannerList", function() { return getBannerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editBanner", function() { return editBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateStatus", function() { return updateStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeBanner", function() { return removeBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBanner", function() { return createBanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var getBannerList = function getBannerList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/banner/getBannerList',
    method: 'POST',
    data: data
  });
};
var editBanner = function editBanner(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/banner/editBanner',
    method: 'POST',
    data: data
  });
};
var updateStatus = function updateStatus(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/banner/updateStatus',
    method: 'POST',
    data: data
  });
};
var removeBanner = function removeBanner(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/banner/remove',
    method: 'POST',
    data: data
  });
};
var createBanner = function createBanner(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/banner/createBanner',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBookList", function() { return getBookList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postUpdateBook", function() { return postUpdateBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postAddBook", function() { return postAddBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBookRecommendList", function() { return getBookRecommendList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postDeleteBookRecommend", function() { return postDeleteBookRecommend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postAddRecommend", function() { return postAddRecommend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postBookSort", function() { return postBookSort; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var getBookList = function getBookList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/listBooks',
    method: 'POST',
    data: data
  });
};
var postUpdateBook = function postUpdateBook(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/updateBookStatus',
    method: 'POST',
    data: data
  });
};

var postAddBook = function postAddBook(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/updateBook',
    method: 'POST',
    data: data
  });
};

var getBookRecommendList = function getBookRecommendList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/listBookRecommend',
    method: 'POST',
    data: data
  });
};

var postDeleteBookRecommend = function postDeleteBookRecommend(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/deleteBookRecommend',
    method: 'POST',
    data: data
  });
};

var postAddRecommend = function postAddRecommend(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/addBookRecommend',
    method: 'POST',
    data: data
  });
};

var postBookSort = function postBookSort(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/moveBookRecommendSequence',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCaseClassList", function() { return getCaseClassList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editCaseClass", function() { return editCaseClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addCaseClass", function() { return addCaseClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideCaseClass", function() { return hideCaseClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "caseClassInfoList", function() { return caseClassInfoList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addCaseClassInfo", function() { return addCaseClassInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editCaseClassInfo", function() { return editCaseClassInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delCaseClassInfo", function() { return delCaseClassInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);



var getCaseClassList = function getCaseClassList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case_type/list',
    method: 'GET',
    data: data
  });
};

var editCaseClass = function editCaseClass(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case_type/update',
    method: 'POST',
    data: data
  });
};

var addCaseClass = function addCaseClass(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case_type/insert',
    method: 'POST',
    data: data
  });
};

var hideCaseClass = function hideCaseClass(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case_type/hide_or_open',
    method: 'POST',
    data: data
  });
};

var caseClassInfoList = function caseClassInfoList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case/queryCase',
    method: 'GET',
    data: data
  });
};

var addCaseClassInfo = function addCaseClassInfo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case/insert',
    method: 'POST',
    data: data
  });
};

var editCaseClassInfo = function editCaseClassInfo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case/update',
    method: 'POST',
    data: data
  });
};

var delCaseClassInfo = function delCaseClassInfo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case/delete',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNoteList", function() { return getNoteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDetailList", function() { return getDetailList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDetail", function() { return getDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postDeleteNote", function() { return postDeleteNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImgList", function() { return getImgList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addImage", function() { return addImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postDeletrImage", function() { return postDeletrImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var getNoteList = function getNoteList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/note/list',
    method: 'POST',
    data: data
  });
};

var getDetailList = function getDetailList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/note/detail/list',
    method: 'POST',
    data: data
  });
};

var getDetail = function getDetail(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/note/detail/get',
    method: 'POST',
    data: data
  });
};

var postDeleteNote = function postDeleteNote(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/note/detail/delete',
    method: 'POST',
    data: data
  });
};

var getImgList = function getImgList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/image/list',
    method: 'POST',
    data: data
  });
};

var addImage = function addImage(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/image/save',
    method: 'POST',
    data: data
  });
};

var postDeletrImage = function postDeletrImage(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/image/delete',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExperienceList", function() { return getExperienceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateParentCorrectCount", function() { return updateParentCorrectCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCorrectCount", function() { return updateCorrectCount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var getExperienceList = function getExperienceList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/account/listCorrectUser',
    method: 'POST',
    data: data
  });
};
var updateParentCorrectCount = function updateParentCorrectCount(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/account/updateParentCorrectCount',
    method: 'POST',
    data: data
  });
};
var updateCorrectCount = function updateCorrectCount(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/account/updateCorrectCount',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPull", function() { return getPull; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);

var getPull = function getPull(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
        url: '/zyc/ocr/correct/exampaper/pull',
        method: 'get'
    });
};

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHonoraryList", function() { return getHonoraryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editHonorary", function() { return editHonorary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addHonorary", function() { return addHonorary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "honoraryStatus", function() { return honoraryStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeHonorary", function() { return removeHonorary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var getHonoraryList = function getHonoraryList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/honorQualification/list',
    method: 'GET',
    data: data
  });
};

var editHonorary = function editHonorary(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/honorQualification/edit',
    method: 'POST',
    data: data
  });
};

var addHonorary = function addHonorary(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/honorQualification/create',
    method: 'POST',
    data: data
  });
};

var honoraryStatus = function honoraryStatus(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/honorQualification/updateStatus',
    method: 'POST',
    data: data
  });
};

var removeHonorary = function removeHonorary(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/honorQualification/remove',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryConsult", function() { return queryConsult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateConsult", function() { return updateConsult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "operateConsult", function() { return operateConsult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteConsult", function() { return deleteConsult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insertConsult", function() { return insertConsult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imageGet", function() { return imageGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateImage", function() { return updateImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var queryConsult = function queryConsult(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information/queryInformationByPage',
    method: 'GET',
    data: data
  });
};
var updateConsult = function updateConsult(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information/update',
    method: 'POST',
    data: data
  });
};
var operateConsult = function operateConsult(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information/operate',
    method: 'POST',
    data: data
  });
};
var deleteConsult = function deleteConsult(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information/delete',
    method: 'POST',
    data: data
  });
};
var insertConsult = function insertConsult(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information/insert',
    method: 'POST',
    data: data
  });
};

var imageGet = function imageGet(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information_image/get',
    method: 'GET',
    data: data
  });
};

var updateImage = function updateImage(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information_image/update',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePASS", function() { return changePASS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var login = function login(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/user/login',
    method: 'POST',
    data: data
  });
};

var logout = function logout() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/logout',
    method: 'get'
  });
};

var changePASS = function changePASS(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/user/modifyPassWord',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postMenu", function() { return postMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get_role_menu", function() { return get_role_menu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllMenu", function() { return getAllMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var postMenu = function postMenu(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/menu/get_menu_by_uid',
    method: 'POST',
    data: data
  });
};

var get_role_menu = function get_role_menu(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/role/get_role_menu',
    method: 'POST',
    data: data
  });
};

var getAllMenu = function getAllMenu(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/menu/get',
    method: 'POST'
  });
};

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewsList", function() { return getNewsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewsImg", function() { return addNewsImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewsImgList", function() { return getNewsImgList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "upNewsImg", function() { return upNewsImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNew", function() { return addNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "upNew", function() { return upNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opNew", function() { return opNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delNew", function() { return delNew; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);




var getNewsList = function getNewsList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information/queryInformationByPage',
    method: 'GET',
    data: data
  });
};

var addNewsImg = function addNewsImg(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information_image/insert',
    method: 'GET',
    data: data
  });
};

var getNewsImgList = function getNewsImgList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information_image/get',
    method: 'GET',
    data: data
  });
};

var upNewsImg = function upNewsImg(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information_image/update',
    method: 'POST',
    data: data
  });
};

var addNew = function addNew(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information/insert',
    method: 'POST',
    data: data
  });
};

var upNew = function upNew(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information/update',
    method: 'POST',
    data: data
  });
};

var opNew = function opNew(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information/operate',
    method: 'POST',
    data: data
  });
};

var delNew = function delNew(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/information/delete',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postRole", function() { return postRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addUser", function() { return addUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteUser", function() { return deleteUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);

var postRole = function postRole(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/role/list',
    method: 'POST',
    data: data
  });
};
var addUser = function addUser(data, url) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: url,
    method: 'POST',
    data: data
  });
};
var deleteUser = function deleteUser(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/role/delete',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "query", function() { return query; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "operate", function() { return operate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCase", function() { return deleteCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insertCase", function() { return insertCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCase", function() { return updateCase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(2);


var query = function query(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case/query',
    method: 'GET',
    data: data
  });
};
var operate = function operate(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case/operate',
    method: 'POST',
    data: data
  });
};
var deleteCase = function deleteCase(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case/delete',
    method: 'POST',
    data: data
  });
};
var insertCase = function insertCase(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case/insert',
    method: 'POST',
    data: data
  });
};
var updateCase = function updateCase(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/backend/case/update',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_reset_css__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_quill_editor__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_quill_dist_quill_core_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_quill_dist_quill_snow_css__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_quill_dist_quill_bubble_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_quill_dist_quill_bubble_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_title__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__http_index__ = __webpack_require__(99);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__http_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_quill_editor___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (to.meta.title) {
        document.title = to.meta.title;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__libs_title__["a" /* wxSetTitle */])(to.meta.title);
    }
    next();
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */],
    template: '<router-view></router-view>'
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    conUser: {}
  },
  getters: {
    getConUser: function getConUser(state) {
      return conUser;
    }
  }
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        menuTree: []
    },
    getters: {
        setMenuTree: function setMenuTree(state, menuTree) {
            state.menuTree = menuTree;
        }
    },
    mutations: {
        setMenuTree: function setMenuTree(state, menuTree) {
            state.menuTree = menuTree;
        }
    }
});

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = $axios;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(58);






var baseURL = '/api';
function $axios(options) {
  var contentType = void 0;
  if (options.type == 'json') {
    contentType = 'application/json';
  } else {
    contentType = 'application/x-www-form-urlencoded';
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
      baseURL: baseURL,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': contentType
      },
      transformResponse: [function (data) {}]
    });

    instance.interceptors.request.use(function (config) {
      var token = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('token');

      if (token) {
        config.headers.token = token;
      } else {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/login');
      }

      if (config.method === 'post') {
        if (config.data && config.data.__proto__ === FormData.prototype || config.url.endsWith('path') || config.url.endsWith('mark') || config.url.endsWith('patchs')) {} else {
          if (config.type == 'json') {} else {
            config.data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(config.data);
          }
        }
      } else {
        if (config.data) {
          config.data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(config.data);
          config.url = config.url + "?" + config.data;
        } else {
          var url = config.url;
          config.url = url;
        }
      }
      return config;
    }, function (error) {
      console.log('request:', error);

      if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
        console.log('timeout请求超时');
      }

      var errorInfo = error.response;
      console.log(errorInfo);
      if (errorInfo) {
        error = errorInfo.data;
        var errorStatus = errorInfo.status;
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({
          path: '/error/' + errorStatus
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    instance.interceptors.response.use(function (response) {
      var data = void 0;

      if (response.data == undefined) {
        data = JSON.parse(response.request.responseText);
      } else {
        data = response.data;
      }
      if (data && data.ret_code === -1) {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/login');
        return false;
      } else {
        return data;
      }
    }, function (err) {
      if (err && err.response) {
        switch (err.response.status) {
          case 400:
            err.message = '请求错误';
            break;
          case 401:
            err.message = '未授权，请登录';
            break;
          case 403:
            err.message = '拒绝访问';
            break;
          case 404:
            err.message = '\u8BF7\u6C42\u5730\u5740\u51FA\u9519: ' + err.response.config.url;
            break;
          case 408:
            err.message = '请求超时';
            break;
          case 500:
            err.message = '服务器内部错误';
            break;
          case 501:
            err.message = '服务未实现,请登录';
            __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/login');
            break;
          case 502:
            err.message = '网关错误';
            break;
          case 503:
            err.message = '服务不可用';
            break;
          case 504:
            err.message = '网关超时';
            break;
          case 505:
            err.message = 'HTTP版本不受支持';
            break;
          default:
        }
      }
      console.error(err);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    });

    instance(options).then(function (res) {
      resolve(res);
      return false;
    }).catch(function (error) {
      reject(error);
    });
  });
}

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);


var login = function login() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 269));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 266));
};
var CaseManagements = function CaseManagements() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 260));
};
var CaseDetails = function CaseDetails() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 259));
};
var NewsManage = function NewsManage() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 270));
};
var HonoraryManage = function HonoraryManage() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 267));
};
var addCase = function addCase() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 261));
};
var editCase = function editCase() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 263));
};
var informationCenter = function informationCenter() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 265));
};
var editConsulte = function editConsulte() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 264));
};
var addConsulte = function addConsulte() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 262));
};
var bannerManage = function bannerManage() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 256));
};
var editBanner = function editBanner() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 257));
};
var addBanner = function addBanner() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 255));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/login',
    name: 'Login',
    component: login,
    meta: {
      title: '官网管控台'
    }
  }, {
    path: '/home',
    name: '当前位置',
    component: Home,
    children: [{
      path: '/caseManagement',
      name: '客户案例管理',
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(0).then((function () {
          return r(__webpack_require__(64));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      children: [{
        path: '/',
        name: '案例分类',
        component: function component(r) {
          return __webpack_require__.e/* require.ensure */(0).then((function () {
            return r(__webpack_require__(64));
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        },
        meta: {
          title: '案例分类'
        },
        redirect: '/caseManagements'
      }, {
        path: '/caseManagements',
        name: '案例分类',
        component: CaseManagements,
        meta: {
          title: '案例分类'
        }
      }, {
        path: '/CaseDetail',
        name: '案例详情',
        component: function component(r) {
          return __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
            return r(__webpack_require__(64));
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        },
        meta: {
          title: '案例详情'
        },
        redirect: '/CaseDetails'
      }, {
        path: '/caseDetails',
        name: '案例详情',
        component: CaseDetails,
        meta: {
          title: '案例详情'
        }
      }]
    }, {
      path: '/bannerManages',
      name: 'banner管理',
      component: bannerManage,
      meta: {
        title: 'banner管理'
      },
      children: []
    }, {
      path: '/bannerManage',
      name: 'banner管理',
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(17).then((function () {
          return r(__webpack_require__(258));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      meta: {
        title: 'banner管理'
      },
      redirect: '/bannerManages',
      children: [{
        path: '/bannerManage/editBanner',
        name: '编辑',
        component: editBanner,
        meta: {
          title: '编辑'
        }
      }, {
        path: '/bannerManage/addBanner',
        name: '添加',
        component: addBanner,
        meta: {
          title: '添加'
        }
      }]
    }, {
      path: '/newsManages',
      name: '新闻资讯管理',
      component: NewsManage,
      meta: {
        title: '新闻资讯管理'
      },
      children: []
    }, {
      path: '/newsManage',
      name: '新闻资讯管理',
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(15).then((function () {
          return r(__webpack_require__(271));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '新闻资讯管理'
      },
      redirect: '/newsManages',
      children: [{
        path: '/newsManage/addConsulte',
        name: '添加新闻资讯',
        component: addConsulte,
        meta: {
          title: '添加新闻资讯'
        }
      }, {
        path: '/newsManage/editConsulte',
        name: '编辑新闻资讯',
        component: editConsulte,
        meta: {
          title: '编辑新闻资讯'
        }
      }]
    }, {
      path: '/honoraryManages',
      name: '荣誉资质管理',
      component: HonoraryManage,
      meta: {
        title: '荣誉资质管理'
      },
      children: []
    }, {
      path: '/honoraryManage',
      name: '荣誉资质管理',
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(16).then((function () {
          return r(__webpack_require__(268));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '荣誉资质管理'
      },
      redirect: '/honoraryManages'
    }]
  }]
});
router.beforeEach(function (to, from, next) {
  var token = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('token');
  if (token) {
    if (to.path == '/') {
      next('/login');
    } else {
      next();
    }
  } else {
    if (to.path == '/login') {
      next();
    } else {
      next('/login');
    }
  }
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(156);




var install = function install(Vue) {
  if (install.installed) return;

  install.installed = true;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
    $api: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */];
      }
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (install);

/***/ })

},[172]);


// WEBPACK FOOTER //
// static/js/app.fdf3351c8526935e81f0.js